import { render, staticRenderFns } from "./AppBreadcrumb.vue?vue&type=template&id=04b4c331&scoped=true"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./AppBreadcrumb.vue?vue&type=style&index=0&id=04b4c331&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b4c331",
  null
  
)

export default component.exports